var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section-title", { staticClass: "mt-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.applicantName) +
            ",\n    " +
            _vm._s(
              _vm.$t("application-standalone.pages.assets.tellUsAboutThisAsset")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.assetTypeVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.assets.type"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("assetType.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("select-field", {
                        attrs: {
                          value: _vm.assetType,
                          placeholder: _vm.$t("application-form.asset-type"),
                          options: _vm.assetTypeOptions,
                          validator: _vm.getValidator("assetType"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.assetType = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "page-section-group-layout",
                [
                  _c("section-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "application-standalone.questions.assets.owner"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("select-field", {
                    attrs: {
                      value: _vm.assetOwner,
                      placeholder: _vm.$t(
                        "application-standalone.questions.assets.owner"
                      ),
                      options: _vm.applicantsAsOptions,
                      "allow-empty": false,
                    },
                    on: { "update:value": _vm.handleOwnerChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.assetDescriptionVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.labels.assetDescription"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("assetDescription.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("text-field", {
                        attrs: {
                          value: _vm.assetDescription,
                          placeholder: _vm.assetDescriptionPlaceholder,
                          validator: _vm.getValidator("assetDescription"),
                          label: _vm.$t(
                            "application-standalone.labels.assetDescription"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.assetDescription = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assetAmountVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.assets.amount"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("assetAmount.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("currency-field", {
                        attrs: {
                          value: _vm.assetAmount,
                          validator: _vm.getValidator("assetAmount"),
                          label: _vm.$t(
                            "application-standalone.questions.assets.amount"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.assetAmount = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }